"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBuy = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const enum_1 = require("../common/enum");
const useCheckOrder_1 = require("./useCheckOrder");
const useComponent_1 = require("./useComponent");
const useErrorMessage_1 = require("./useErrorMessage");
const useFormBridge_1 = require("./useFormBridge");
const useInject_1 = require("./useInject");
const useOrderItem_1 = require("./useOrderItem");
const useQueryPrice_1 = require("./useQueryPrice");
const useResource_1 = require("./useResource");
const useSpuParam_1 = require("./useSpuParam");
function useBuy(spuCode, scene, asyncResource, plugin = {}) {
    const { spuMeta_, paramList_, strategyList_, validator_, spuMeta, paramList, loaded_ } = (0, useResource_1.useResource)(spuCode, scene, asyncResource);
    // 初始化插件
    const { checkOrder: checkOrderProps, queryPrice: queryPriceProps, importValues: importValuesProps, errorMessage: errorMessageProps, inject: injectProps, } = plugin;
    const injectModule = (0, useInject_1.useInject)(injectProps);
    // 声明内部参数值
    const { effectiveValues, setCurrentValues, setImportedValues, setDefaultValues, setParamBehavior, effectiveValues_, getFlatValues, } = (0, useSpuParam_1.useSpuParam)({ paramList }, importValuesProps);
    const effectiveValues_Ref = (0, react_1.useRef)();
    const setCurrentValuesRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        effectiveValues_Ref.current = effectiveValues_;
        setCurrentValuesRef.current = setCurrentValues;
    }, [effectiveValues_, setCurrentValues]);
    const { components, componentList_ } = (0, useComponent_1.useComponent)({
        spuMeta_,
        paramList_,
        strategyList_,
        validator_,
        values_: effectiveValues_,
        loaded_,
    }, {
        setCurrentValues,
        setDefaultValues,
        setParamBehavior,
    });
    // 创建订阅关系
    const { orderItem_, orderItemWithTimeout_ } = (0, useOrderItem_1.useOrderItem)(spuCode, {
        paramList_,
        values_: effectiveValues_,
        validator_,
    }, injectModule[enum_1.InjectablePoint.OnBuildOrderItem]);
    const checkOrderModule = (0, useCheckOrder_1.useCheckOrder)({ orderItem_ }, checkOrderProps, injectModule[enum_1.InjectablePoint.OnCheckOrder]);
    const queryPriceModule = (0, useQueryPrice_1.useQueryPrice)({ orderItem_ }, queryPriceProps, injectModule[enum_1.InjectablePoint.OnQueryPrice]);
    const _a = (0, useErrorMessage_1.useErrorMessage)({ componentList_ }, errorMessageProps), { customValidator } = _a, errorMessageModule = __rest(_a, ["customValidator"]);
    const { errors, onChange, validateFieldBuilder, formStatus, validate, submit } = (0, useFormBridge_1.useFormBridge)({ validator_, values_: effectiveValues_ }, { setCurrentValues }, { checkOrder: checkOrderModule, customValidator });
    // 有可能拿不到，设置超时
    const getOrderItem = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () { return yield (0, rxjs_1.firstValueFrom)(orderItemWithTimeout_); }), [orderItemWithTimeout_]);
    const resetValues = (0, react_1.useCallback)(() => {
        setCurrentValues({});
        setImportedValues({});
    }, [setCurrentValues, setImportedValues]);
    // 暴露给外部
    return {
        spuMeta,
        paramList,
        current: effectiveValues,
        getFlatValues,
        getOrderItem,
        resetValues,
        components,
        formStatus,
        errors,
        onChange,
        validate,
        submit,
        validateFieldBuilder,
        errorMessage: errorMessageModule,
        queryPrice: queryPriceModule,
        controlledValues: {
            effectiveValues_: effectiveValues_Ref,
            setCurrentValues: setCurrentValuesRef,
        },
    };
}
exports.useBuy = useBuy;
